"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #ebebeb;\n      }\n\n      .cls-3, .cls-5 {\n        opacity: 0.06;\n      }\n\n      .cls-4 {\n        fill: #e60000;\n      }\n    ")), /*#__PURE__*/React.createElement("title", null, "sync-hi"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-1",
    width: 192,
    height: 192
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 96,
    cy: 96,
    r: 79.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96,174A79.94,79.94,0,0,1,16.07,95c0,.33,0,.66,0,1A80,80,0,0,0,176,96c0-.34,0-.67,0-1A79.94,79.94,0,0,1,96,174Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.38,87.43a3.12,3.12,0,0,0-6.18.9,45.32,45.32,0,0,1,.47,6.5A44.72,44.72,0,0,1,96,139.5a44.25,44.25,0,0,1-32.43-14h22a3.12,3.12,0,0,0,0-6.24H57.77a3.12,3.12,0,0,0-3.12,3.12v28a3.12,3.12,0,1,0,6.24,0V131.7a50.43,50.43,0,0,0,35.11,14,51,51,0,0,0,50.91-50.91A52.09,52.09,0,0,0,146.38,87.43Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.77,152a3.12,3.12,0,0,1-3.12-3.12v1.56a3.12,3.12,0,1,0,6.24,0v-1.56A3.12,3.12,0,0,1,57.77,152Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.57,125.55h22a3.11,3.11,0,0,0,3.12-3.12,2.88,2.88,0,0,0-.11-.78,3.09,3.09,0,0,1-3,2.34H62.36Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.23,38.44a3.12,3.12,0,0,0-3.12,3.12V60.3A50.43,50.43,0,0,0,96,46.26,51,51,0,0,0,45.09,97.17a52.09,52.09,0,0,0,.53,7.4,3.13,3.13,0,0,0,3.09,2.67,3.4,3.4,0,0,0,.45,0,3.12,3.12,0,0,0,2.64-3.54,45.42,45.42,0,0,1-.47-6.5A44.72,44.72,0,0,1,96,52.5a44.26,44.26,0,0,1,32.37,13.88H106.43a3.12,3.12,0,0,0,0,6.24h27.8a3.12,3.12,0,0,0,3.12-3.12V41.56A3.12,3.12,0,0,0,134.23,38.44Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.75,103.25a3.11,3.11,0,0,1-6.12-.24,50,50,0,0,1-.52-6.49c0,.22,0,.43,0,.65a50.66,50.66,0,0,0,.54,7.4,3.12,3.12,0,1,0,6.17-.9C51.78,103.53,51.77,103.39,51.75,103.25Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.65,93.8c0-.24,0-.48,0-.73a45.7,45.7,0,0,0-.4-6,3,3,0,0,0-.07,1.23A45.33,45.33,0,0,1,140.65,93.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.89,131.72a50.46,50.46,0,0,0,35.11,14,51,51,0,0,0,50.91-50.91c0-.34,0-.68,0-1A51,51,0,0,1,96,144a50.44,50.44,0,0,1-35.2-14.1Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.37,66.38l1.2,0a15.11,15.11,0,0,0-1.22-1.57h0A44.25,44.25,0,0,0,96,50.94,44.71,44.71,0,0,0,51.33,95.6c0,.31,0,.61,0,.92a44.67,44.67,0,0,1,77-30.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.43,71.06h27.81a3.12,3.12,0,0,0,3-2.34,2.88,2.88,0,0,1,.11.78,3.12,3.12,0,0,1-3.12,3.12H106.43a3.07,3.07,0,0,1-3.12-3.12,3,3,0,0,1,.44-1.56C103.75,69.66,104.71,71.06,106.43,71.06Z",
    transform: "translate(0 0)"
  }));
}

var _default = ic_sync;
exports.default = _default;